import { forwardRef } from 'react';
import { Player } from '@unboared/react';
import classNames from 'classnames';
import { Avatar } from '~/components/design/avatar';

import styles from './PositionLabel.module.css';

/* Propeties of score position components */
export type PositionLabelProps = {
    /* The player */
    player: Player;
    /* The position of the player */
    position: number;
    /* Additional styles for the component */
    style?: React.CSSProperties;
    /* Additional classnames for the component */
    className?: string;
    /* The score */
    score: number;
};

/**
 * Displays the highscore of a player rankek after the third position.
 */
// eslint-disable-next-line react/display-name
export const PositionLabel = forwardRef<HTMLDivElement, PositionLabelProps>((props: PositionLabelProps, ref) => {
    /* Get properties */
    const { className, style, position, player, score } = props;

    return (
        <div ref={ref} className={classNames(styles.container, className, style)}>
            {/* The position of the player */}
            <div className={styles.positionContainer}>
                <p className={classNames(styles.bigNumber, styles.arco)}>{position}</p>
            </div>
            {/* The informations about the player */}
            <div className={styles.content}>
                <Avatar className={styles.avatar} src={player.avatar} />
                {/* `ub-mask` : pseudo de joueur masqué dans les enregistrements de session (PostHog). */}
                <p className={classNames(styles.username, 'singleLine', 'ub-mask')}>{player.username}</p>
            </div>
            {/* The score of the player */}
            <div className={styles.scoreContainer}>
                <p className={styles.arco}>{score}</p>
            </div>
        </div>
    );
});
